import OrderFlowDeliveryPage from '../pages/flow/OrderFlowDeliveryPage'
import OrderFlowKitchenPage from '../pages/flow/OrderFlowKitchenPage'
import OrderFlowOvenPage from '../pages/flow/OrderFlowOvenPage'
import OrderFlowPage from '../pages/flow/OrderFlowPage'
import OrderFlowSalon from '../pages/flow/OrderFlowSalonPage'


const routes = [
    {
        name: 'OrderFlowPage',
        path: '/flow/bar',
        component: OrderFlowPage,
        permission: "ORDER_SHOW_BAR"
    },
    {
        name: 'OrderFlowKitchenPage',
        path: '/flow/kitchen',
        component: OrderFlowKitchenPage,
        permission: "ORDER_SHOW_KITCHEN"
    },
    {
        name: 'OrderFlowOvenPage',
        path: '/flow/oven',
        component: OrderFlowOvenPage,
        permission: "ORDER_SHOW_OVEN"
    },
    {
        name: 'OrderFlowDeliveryPage',
        path: '/flow/delivery',
        component: OrderFlowDeliveryPage,
        permission: "ORDER_SHOW_DELIVERY"
    },
    {
        name: 'OrderFlowSalonPage',
        path: '/flow/salon',
        component: OrderFlowSalon,
        permission: "ORDER_SHOW_BAR" // TODO Hacer el permiso para salon
    }

]

export default routes;
